import { render, staticRenderFns } from "./Single.vue?vue&type=template&id=5734dea7&scoped=true&"
import script from "./Single.vue?vue&type=script&lang=ts&"
export * from "./Single.vue?vue&type=script&lang=ts&"
import style0 from "./Single.vue?vue&type=style&index=0&id=5734dea7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5734dea7",
  null
  
)

export default component.exports